<template>
  <div class="sidebar-widgets-container">
    <GraphTableTotal
      v-if="showPieChart"
      data-test="sidebar-widget-pie-chart"
      :style="pieChartFontFamily"
    />
    <SummaryTable
      data-test="sidebar-widget-summary-table"
      class="my-4"
    />
    <ComparisonGraph
      v-if="showComparisonGraph"
      data-test="sidebar-widget-bar-chart"
    />
  </div>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import GraphTableTotal from '@/components/public/GraphTable/GraphTableTotal.vue'
import SummaryTable from '@/components/public/SummaryTable/SummaryTable.vue'
import ComparisonGraph from '@/components/public/Charts/ComparisonGraph.vue'

import { PATH_ROOT, PATH_SUBROOT } from '@/constants'

const components = {
  GraphTableTotal,
  SummaryTable,
  ComparisonGraph,
}

@Component({ components })
export default class SidebarWidgets extends Vue {
  get activeTab () {
    return this.$typedStore.public.display.activeTab
  }

  get activeTabPath () {
    if (this.activeTab) return this.activeTab.path
  }

  get hidePieChartOnRootSubroot () {
    return this.$typedStore.activeVisualisation.visualisationStore.app.config.appConfig.hidePiechartOnRootSubroot
  }

  get showPieChartSidebar () {
    return this.$typedStore.activeVisualisation.visualisationStore.app.config.appConfig.showPiechartSidebar
  }

  get showPieChart () {
    const isRoot = this.activeTabPath === PATH_ROOT
    const isSubroot = this.activeTabPath === PATH_SUBROOT
    if (this.hidePieChartOnRootSubroot) return !isRoot && !isSubroot && this.showPieChartSidebar
    else return this.showPieChartSidebar
  }

  get sidebarBotFontFamily () {
    return this.$typedStore.activeVisualisation.visualisationStore.app.config.storySettings.sidebarBot.fontFamily
  }

  get pieChartFontFamily () {
    return {
      '--font-family': this.sidebarBotFontFamily,
      'font-family': this.sidebarBotFontFamily,
    }
  }

  get showComparisonGraph () {
    return this.$typedStore.activeVisualisation.visualisationStore.app.config.comparisonGraphSettings.show
  }
}

</script>

<style>

.sidebar-widgets-container .graph-table-container {
  font-family: var(--font-family);
}

.sidebar-widgets-container .graph-table-container .table {
  color: inherit;
}

.sidebar-widgets-container .summary-table-container .table {
  color: inherit;
}

</style>
